import { utils } from "ethers";

/**
 *  @returns "0xAeeff2e9388A578C02754Cd08699652fB76035C7" for "XRP"
 */
export const getSyntheticAssetAddress = (symbol: string) => {
  return utils.getAddress(utils.hexDataSlice(utils.solidityKeccak256(['string'], [symbol.toUpperCase()]), 12))
}
